import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { Project } from '@connect-services/client/sdk/api';
import { DataExportService, ExportFormat } from '@connect-services/client/services/data-export.service';
import { ProjectService } from '@connect-services/client/services/project.service';
import { SelectComponent, SelectOption } from '@connect-services/src/lib/components/select/select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import ProjectionEnum = Project.ProjectionEnum;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule, SelectComponent],
    selector: 'app-common-information',
    templateUrl: './common-information.component.html',
})
export class CommonInformationComponent implements OnInit {
    protected readonly dataExportService = inject(DataExportService);
    protected readonly defaultFormatOption = computed<SelectOption<ExportFormat>[]>(() =>
        this.formatOptions.filter(
            (option: SelectOption<ExportFormat>) => option.value === this.dataExportService.format(),
        ),
    );
    protected readonly defaultProjectionOption = computed<SelectOption<ProjectionEnum>[]>(() =>
        this.projectionOptions.filter(
            (option: SelectOption<ProjectionEnum>) => option.value === this.dataExportService.projection(),
        ),
    );
    protected readonly ExportFormat = ExportFormat;
    protected formatOptions: SelectOption<ExportFormat>[] = [];
    protected projectionOptions: SelectOption<Project.ProjectionEnum>[] = [];

    private readonly projectService = inject(ProjectService);
    private readonly translocoService = inject(TranslocoService);

    public ngOnInit(): void {
        this.formatOptions = Object.entries(ExportFormat).map(([key, value]: [string, ExportFormat]) => {
            return { label: this.translocoService.translate(key.toLowerCase()), value };
        });

        this.projectionOptions = this.initProjectionOption();
    }

    protected selectFormat(event: ExportFormat[]): void {
        this.dataExportService.format.set(event[0]);
        if (event[0] === ExportFormat.KML) {
            this.dataExportService.projection.set(Project.ProjectionEnum._4326);

            return;
        }

        if (this.dataExportService.projection()) {
            return;
        }
        this.dataExportService.projection.set(this.dataExportService.defaultProjection());
    }

    protected selectProjection(projection: Project.ProjectionEnum[]): void {
        this.dataExportService.projection.set(projection[0]);
    }

    private initProjectionOption(): SelectOption<Project.ProjectionEnum>[] {
        return Object.values(Project.ProjectionEnum).map((projectionCode: Project.ProjectionEnum) => ({
            label: this.projectService.getProjectionText(projectionCode),
            value: projectionCode,
        }));
    }
}
